/**
 * # Contact
 */

/**
 * ## Imports
 */
import { ClientName } from 'client/clientConfig';
import PageFooter from 'common/components/PageFooter/PageFooter';
import PageHeader from 'common/components/PageHeader/PageHeader';
import ContactBox from 'common/components/ContactBox/ContactBox';

/**
 * ## Component
 */
const ContactPage = () => {
    const appClassName = `app ${ClientName ? `app--${ClientName}` : ''}`;

    return (
        <div className={appClassName}>
            <h1 className="sr-only">Contact Page</h1>
            <PageHeader clientName={ClientName} />
            <ContactBox />
            <PageFooter clientName={ClientName} />
        </div>
    );
};

export default ContactPage;
